module.exports = __webpack_public_path__ + "static/media/bubble.334e3ee3.png";